var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdTreatment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10659_3054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#EFF0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 26C27.3137 26 30 23.3137 30 20C30 16.6863 27.3137 14 24 14C20.6863 14 18 16.6863 18 20C18 23.3137 20.6863 26 24 26Z",
    stroke: "#8152E0",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6316 19.3602V17.6294C24.6316 17.4624 24.5651 17.3024 24.4466 17.1844C24.3281 17.0663 24.1675 17 24 17C23.8325 17 23.6719 17.0663 23.5534 17.1844C23.4349 17.3024 23.3684 17.4624 23.3684 17.6294V19.3602H21.6316C21.4641 19.3602 21.3035 19.4265 21.185 19.5445C21.0666 19.6625 21 19.8226 21 19.9895C21 20.1565 21.0666 20.3166 21.185 20.4345C21.3035 20.5526 21.4641 20.6189 21.6316 20.6189H23.3684M24.6316 19.3707H26.3684C26.5359 19.3707 26.6965 19.437 26.815 19.555C26.9334 19.673 27 19.8331 27 20C27 20.1669 26.9334 20.327 26.815 20.445C26.6965 20.5631 26.5359 20.6294 26.3684 20.6294H24.6316M24.6316 20.6399V22.3706C24.6316 22.5376 24.5651 22.6977 24.4466 22.8156C24.3281 22.9337 24.1675 23 24 23C23.8325 23 23.6719 22.9337 23.5534 22.8156C23.4349 22.6977 23.3684 22.5376 23.3684 22.3706V20.6399",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 29.0605H30.9299M18 33.4756H30.9299",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 11.4004H15.0625C13.924 11.4004 13 12.3711 13 13.5671V35.2337C13 36.4297 13.924 37.4004 15.0625 37.4004H32.9375C34.076 37.4004 35 36.4297 35 35.2337V13.5671C35 12.3711 34.076 11.4004 32.9375 11.4004H21.25Z",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10659_3054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdTreatment);
export default __webpack_public_path__ + "static/media/sd-treatment.56448913d1b14d422ca2c790492ca361.svg";
export { ForwardRef as ReactComponent };